<template>
  <div
    :class="[
      'w-full text-[1rem] text-center leading-[1.5rem] rounded-[16px] font-medium p-[16px] border-[#A5A4A3]',
      isSelected
        ? 'bg-[#E8DCC766] text-[#000000] font-bold border-[2px]'
        : 'bg-[#FFFFFF] text-[#0B0C0F] border',
    ]"
    @click="$emit('click')"
  >
    {{ text }}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
};
</script>
